/* eslint-disable */

<template>
  <div class="simulation-container">
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div :class="{ 'cursor-drag': draggingCard === true }" class="grid grid-cols-12 gap-6">
        <div class="col-span-12 lg:col-span-4 md:col-span-4">
          <vx-card class="mb-base">
            <span class="flex items-center justify-between mb-5">
              <h3 class="text-xl font-bold text-white">Commands</h3>
              <vs-button size="small" @click="toggleLogModal" class="">📜 View Login Log</vs-button>
            </span>
            <vue-draggable-container id="wordBank" class="rounded-lg command-bank">
              <h5 v-for="command in commands" :key="command" class="dragBlock command-chip font-semibold cursor-pointer text-sm">{{ command }}</h5>
            </vue-draggable-container>
          </vx-card>
        </div>

        <div class="col-span-12 lg:col-span-8 md:col-span-8 min-w-0">
          <div class="terminal-windows space-y-6">
            <vx-card>
              <div class="terminal-command-row">
                <h2 class="terminal-prompt">[tim@localhost exercise]$</h2>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg flex-grow min-w-0" id="input0" />
              </div>
              <div class="terminal-output-box bg-light rounded-lg mt-6 p-4 main-border">
                <pre class="terminal-line">{{ terminalOutputs.output1 }}</pre>
              </div>
            </vx-card>

            <vx-card>
              <div class="terminal-command-row">
                <h2 class="terminal-prompt">[tim@localhost exercise]$</h2>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg flex-grow min-w-0" id="input1" />
              </div>
              <div class="terminal-output-box bg-light rounded-lg mt-6 p-4 main-border">
                <pre class="terminal-line">{{ terminalOutputs.output2 }}</pre>
              </div>
            </vx-card>

            <vx-card>
              <div class="terminal-command-row">
                <h2 class="terminal-prompt">[tim@localhost exercise]$</h2>
                <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg flex-grow min-w-0" id="input2" />
              </div>
              <div class="terminal-output-box bg-light rounded-lg mt-6 p-4 main-border">
                <h3 v-for="line in terminalOutputs.output3" :key="line" class="terminal-line">{{ line }}</h3>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
    </vue-sortable>

    <movable-popup
      ref="logModal"
      refVal="logModalRef"
      title="📜 Login Log File Contents - Click Here to Drag Window"
      :z-index="999999"
      :active="showLogModal"
      v-on:close="showLogModal = false"
      padding="0"
    >
      <template v-slot:content>
        <div class="modal-content">
          <div class="modal-body">
            <pre class="log-content">{{ logFileContent }}</pre>
          </div>
        </div>
      </template>
    </movable-popup>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Prism from 'vue-prism-component';
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,
      showLogModal: false,
      commands: [
        'grep "Mar 13" lastlog',
        'tr "[A-Z]" "[a-z]" < lastlog | grep "mar 12"',
        "awk '{ print toupper ($0) }' lastlog",
        'tr "[a-z]" "[A-Z]" < lastlog | grep -i "mar 12"',
        "awk '{ print $1 }' lastlog | sort | uniq",
        "awk '{ print $1 }' lastlog | uniq",
        "awk '{ print $2 }' lastlog | sort | uniq",
        'grep lastlog "Mar 13"',
        'grep Mar 13 lastlog',
        "awk '{ print $1 }' lastlog | sort | uniq -c",
        'grep "Mar13" lastlog',
        'grep -i "mar 12" lastlog sed \'s/ [a-z]/[A-Z]/g\'',
      ],
      terminalOutputs: {
        output1: `eric	pts/3		:0		Mon Mar 13 10:52 - 08:48 (1+12:50)
david	pts/3		:0		Mon Mar 13 10:52 - 08:48 (1+12:50)
ann	pts/3		:0		Mon Mar 13 10:52 - 08:48 (1+12:50)
chris	pts/3		:0		Mon Mar 13 13:30 - 08:48 (1+12:50)
carl	pts/3		:0		Mon Mar 13 10:52 - 08:48 (1+12:50)
zoe	pts/3		:0		Mon Mar 13 09:57 - 08:48 (1+12:50)
lee	pts/3		:0		Mon Mar 13 11:52 - 08:48 (1+12:50)`,
        output2: `EVOLVE	PTS/1		:0			SUN MAR 12 14:20 - 09:48 (1+19:28)
CHRIS	PTS/2		:0			SUN MAR 12 14:52 - 09:48 (1+18:56)
REBOOT	SYSTEM BOOT	3.10.0-693.21.1.	SUN MAR 12 11:01 - 13:26 (2+02:24)
LEE	PTS/2		:0			SUN MAR 12 14:52 - 09:48 (1+18:56)
EVOLVE	PTS/0		:0			SUN MAR 12 14:14 - 14:22 (00:07)
ERIC	PTS/2		:0			SUN MAR 12 14:52 - 09:48 (1+18:56)
EVOLVE	PTS/0		:0			SUN MAR 12 11:37 - 11:58 (00:20)
REBOOT	SYSTEM BOOT	3.10.0-693.21.1.	SUN MAR 12 11:02 - 13:26 (2+02:23)
DAVID	PTS/2		:0			SUN MAR 12 14:52 - 09:48 (1+18:56)
EVOLVE	PTS/0		:0			SUN MAR 12 09:53 - 10:59 (01:05)
EVOLVE	:0		:0			SUN MAR 12 10:59 - 11:01 (00:00)
REBOOT	SYSTEM BOOT	3.10.0-693.21.1.	SUN MAR 12 10:52 - 13:26 (2+02:26)
EVOLVE	:0		:0			SUN MAR 12 14:52 - 13:26 (2+02:22)
EVOLVE	PTS/2		:0			SUN MAR 12 14:52 - 09:48 (1+18:56)
ANN	PTS/2		:0			SUN MAR 12 14:52 - 09:48 (1+18:56)
CARL	PTS/2		:0			SUN MAR 12 09:52 - 09:48 (1+18:56)
REBOOT	SYSTEM BOOT	3.10.0-693.E17.X	SUN MAR 12 14:39 - 10:59 (01:19)`,
        output3: ['ann', 'carl', 'chris', 'david', 'eric', 'evolve', 'lee', 'reboot', 'zoe'],
      },
      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },
      logFileContent: `evolve	pts/1		:0			Sun Mar 12 14:20 - 09:48 (1+19:28)
chris	pts/2		:0			Sun Mar 12 14:52 - 09:48 (1+18:56)
evolve	:0		:0			Tue Mar 14 14:24 - 16:52 (02:28)
reboot	system boot	3.10.0-693.21.1.	Sun Mar 19 13:31 - 13:19 (13+23:47)
evolve	pts/1		:0			Fri Apr 24 09:47 still logged in
reboot	system boot	3.10.0-693.21.1.	Sun Mar 12 11:01 - 13:26 (2+02:24)
evolve	pts/0		:0			Thu Apr 23 14:53 - 15:01 (00:07)
evolve	pts/0		:0			Thu Apr 23 14:49 - 14:49 (00:00)
lee	pts/2		:0			Sun Mar 12 14:52 - 09:48 (1+18:56)
evolve	pts/0		:0			Sun Mar 12 14:14 - 14:22 (00:07)
evolve	:0		:0			Sun Apr 19 10:50 - crash (3+21:02)
evolve	:0		:0			Thu Apr 23 07:57 still logged in
eric	pts/3		:0			Mon Mar 13 10:52 - 08:48 (1+12:50)
eric	pts/2		:0			Sun Mar 12 14:52 - 09:48 (1+18:56)
zoe	pts/3		:0			Wed Mar 15 8:00 - 09:47 (1+10:51)
evolve	pts/0		:0			Sun Mar 12 11:37 - 11:58 (00:20)
evolve	:0		:0			Sun Apr 2 11:16 - down (02:03)
evolve	pts/0		:0			Mon Apr 24 08:55 still logged in
carl	pts/3		:0			Wed Mar 15 8:00 - 09:47 (1+10:51)
reboot	system boot	3.10.0-693.21.1.	Tue Apr 18 13:47 - 10:33 (6+20:45)
ann	pts/3		:0			Wed Mar 15 8:00 - 09:47 (1+10:51)
evolve	:0		:0			Tue Apr 18 13:48 - 14:55 (01:06)
evolve	pts/0		:0			Sun Apr 23 14:44 - 14:44 (00:00)
reboot	system boot	3.10.0-693.21.1.	Sun Mar 12 11:02 - 13:26 (2+02:23)
chris	pts/3		:0			Wed Mar 15 8:00 - 09:47 (1+10:51)
lee	pts/3		:0			Wed Mar 15 8:00 - 09:47 (1+10:51)
david	pts/2		:0			Sun Mar 12 14:52 - 09:48 (1+18:56)
david	pts/3		:0			Mon Mar 13 10:52 - 08:48 (1+12:50)
eric	pts/3		:0			Wed Mar 15 8:00 - 09:47 (1+10:51)
evolve	pts/0		:0			Sun Mar 12 09:53 - 10:59 (01:05)
reboot	system boot	3.10.0-693.21.1.	Sun Apr 23 07:53 - 10:33 (2+02:40)
david	pts/3		:0			Wed Mar 15 8:00 - 09:47 (1+10:51)
reboot	system boot	3.10.0-693.21.1.	Sun Apr 2 11:11 - 13:19 (02:08)
ann	pts/3		:0			Mon Mar 13 10:52 - 08:48 (1+12:50)
evolve	:0		:0			Sun Mar 12 10:59 - 11:01 (00:00)
chris	pts/3		:0			Mon Mar 13 13:30 - 08:48 (1+12:50)
reboot	system boot	3.10.0-693.21.1.	Sun Mar 12 10:52 - 13:26 (2+02:26)
reboot	system boot	3.10.0-693.21.1.	Sun Mar 19 11:03 - 13:19 (13+23:48)
carl	pts/3		:0			Mon Mar 13 10:52 - 08:48 (1+12:50)
evolve	:0		:0			Sun Mar 12 14:52 - 13:26 (2+02:22)
zoe	pts/3		:0			Mon Mar 13 09:57 - 08:48 (1+12:50)
evolve	pts/2		:0			Sun Mar 12 14:52 - 09:48 (1+18:56)
reboot	system boot	3.10.0-693.21.1		Sun Mar 19 13:57 - 13:30 (03:32)
ann	pts/2		:0			Sun Mar 12 14:52 - 09:48 (1+18:56)
evolve	:0		:0			Sun Mar 19 10:13 - 13:29 (00:16)
carl	pts/2		:0			Sun Mar 12 09:52 - 09:48 (1+18:56)
lee	pts/3		:0			Mon Mar 13 11:52 - 08:48 (1+12:50)
reboot	system boot	3.10.0-693.e17.x	Sun Mar 12 14:39 - 10:59 (01:19)
evolve	pts/0		:0			Sun Apr 2 09:26 - 13:19 (01:52)
`,
    };
  },
  methods: {
    startedDrag(x) {
      x.data.source.className += ' currently-dragging-standard';
      this.draggingCard = true;
    },
    stoppedDrag() {
      this.draggingCard = false;
      this.$nextTick(() => {
        const bank = this.$el.querySelector('#wordBank');
        if (!bank) return;
        bank.querySelectorAll('.command-chip').forEach((el) => {
          el.style.removeProperty('width');
          el.style.removeProperty('min-width');
        });
      });
    },
    sort(x) {
      const overContainer = x.data.dragEvent.data.overContainer;
      const sourceContainer = x.data.dragEvent.data.sourceContainer;
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          x.cancel();
        }
      }
    },
    toggleLogModal() {
      if (this.showLogModal === false) {
        this.showLogModal = true;
      } else {
        this.$refs.logModal.close();
      }
    },
    commandText(id) {
      return (document.getElementById(id)?.textContent || '').replace(/\s+/g, ' ').trim();
    },
    markSimulation() {
      let totalScore = 0;
      const answers = [
        ['input0', 'grep "Mar 13" lastlog'],
        ['input1', 'tr "[a-z]" "[A-Z]" < lastlog | grep -i "mar 12"'],
        ['input2', "awk '{ print $1 }' lastlog | sort | uniq"],
      ];

      answers.forEach(([id, expected]) => {
        const input = document.getElementById(id);
        if (this.commandText(id) === expected) {
          totalScore++;
          input.style.borderColor = '#77FAAE';
          input.style.backgroundColor = '#77FAAE';
        } else {
          input.style.borderColor = '#fd4445';
          input.style.backgroundColor = '#fd4445';
        }
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    draggable,
    Prism,
    MovablePopup,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.simulation-container {
  min-height: 100vh;
}

.command-bank-card {
  background: #1a1a1a;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.command-bank {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;

  ::v-deep .command-chip {
    display: inline-flex !important;
    width: fit-content !important;
    min-width: 0 !important;
    max-width: 100%;
    align-self: flex-start;
    flex: 0 0 auto;
    margin: 0;
    box-sizing: border-box;
  }
}

.terminal-card {
  border-radius: 0.5rem;
  overflow: hidden;
  background: #1a1a1a;
}

.terminal-window {
  background: #1a1a1a;
  border: 1px solid #2d2d2d;
  border-radius: 0.375rem;
  padding: 1rem;
  margin-bottom: 1rem;
}

.terminal-windows {
  min-width: 0;
  max-width: 100%;

  ::v-deep .vx-card,
  ::v-deep .vx-card__collapsible-content,
  ::v-deep .vx-card__body {
    min-width: 0;
    max-width: 100%;
  }
}

.terminal-command-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  max-width: 100%;
}

.terminal-prompt {
  color: #0053ff;
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  margin-right: 0.5rem;
  flex-shrink: 0;
}

.terminal-output-box {
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
}

.command-input {
  background: #2d2d2d;
  border: 1px solid #3d3d3d;
  border-radius: 0.25rem;
  min-height: 2rem;
  min-width: 20rem;
  padding: 0.25rem 0.5rem;
  color: white;
  font-family: 'Fira Code', monospace;
}

.terminal-output {
  margin-top: 1rem;
  padding: 1rem;
  background: #2d2d2d;
  border-radius: 0.25rem;
}

.terminal-line {
  color: #f8f8f2;
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 0;
  tab-size: 8;
  white-space: pre;
  width: max-content;
  min-width: 100%;
}

h3.terminal-line {
  margin: 0.25rem 0;
}

.modal-content {
  border-radius: 0.5rem;
  max-height: 75vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1rem 1rem 1rem;
  border-bottom: 1px solid #2d2d2d;
  color: white;
}

.modal-close {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #fd4445;
  }
}

.modal-body {
  padding: 1rem;
}

.log-content {
  font-family: 'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  color: #50fa7b;
  white-space: pre;
  tab-size: 8;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  overflow-x: auto;
  max-width: 100%;
}

.currently-dragging-standard {
  opacity: 0.5;
  transform: scale(0.95);
}

.dropzoneStandard {
  &.answer-bg {
    background-color: #2d2d2d;
    min-height: 2rem;
    border-radius: 0.25rem;
    transition: all 0.2s;

    &:hover {
      background-color: #3d3d3d;
    }
  }
}
</style>
